import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import React, { useCallback } from "react";

import { PATHS } from "@config";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import { Tab, Tabs } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { resetJobs } from "@redux/jobs/actions";
import { removeState } from "@utils/storage";
import isEqual from "lodash/isEqual";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const styles = makeStyles({
  tabActiveColor: {
    backgroundColor: "transparent",
  },
  heightTab: {
    height: "100%",
    color: "#fff",
  },
});

const MyJobBar = () => {
  const classes = styles();
  const paths = [
    PATHS.JOB_APPLY,
    PATHS.JOB_PLAN,
    PATHS.JOB_WORK,
    PATHS.JOB_RESULT_EMPLOYMENT,
    PATHS.JOB_RESULT_SALARY,
  ];
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dispatchResetJobs = useCallback(() => dispatch(resetJobs()), []);

  const subPaths = [PATHS.JOB_RESULT_EMPLOYMENT, PATHS.JOB_RESULT_SALARY];
  const checkShowSubTabs = subPaths.includes(pathname);

  const getValTab = (list, type = "") => {
    if (!type && list.indexOf(pathname) > list.indexOf(PATHS.JOB_RESULT_EMPLOYMENT)) {
      return list.indexOf(PATHS.JOB_RESULT_EMPLOYMENT);
    }
    return list.indexOf(pathname);
  };

  const handleChangeTab = (list, value) => {
    navigate(list[value]);
    removeState();
    if (isEqual(list, paths)) {
      dispatchResetJobs();
    }
  };

  return (
    <>
      <Tabs
        value={getValTab(paths)}
        variant="fullWidth"
        onChange={(e, value) => handleChangeTab(paths, value)}
        classes={{ indicator: styles.tabActiveColor }}
        className="jvs-tab-list"
        sx={{ mt: 2 }}
      >
        <Tab className="jvs-tab-item" icon={<StarBorderIcon />} label="応募中" />
        <Tab className="jvs-tab-item" icon={<NotificationsNoneIcon />} label="就業予定" />
        <Tab className="jvs-tab-item" icon={<PlayCircleFilledIcon />} label="就業中" />
        <Tab className="jvs-tab-item" icon={<CheckCircleIcon />} label="実績" />
      </Tabs>
      {checkShowSubTabs && (
        <Tabs
          value={getValTab(subPaths, "subs")}
          onChange={(e, value) => handleChangeTab(subPaths, value)}
          indicatorColor="primary"
          centered
          classes={{ indicator: classes.tabActiveColor, flexContainer: classes.heightTab }}
          className="jvs-tab-list"
          sx={{ mt: 2, minHeight: "38px" }}
        >
          <Tab className="jvs-tab-item col-6" label="就業実績" />
          <Tab className="jvs-tab-item col-6" label="給与実績" />
        </Tabs>
      )}
    </>
  );
};

MyJobBar.propTypes = {};

export default MyJobBar;
